module.exports = "/_next/static/images/66763fb1ab010d9eabb57bcb25d23f04-hands-holding-cards-md@3x.jpg.webp";